import { MetricDataPointsChannel } from '@tableau/search-microview-communication-channels/lib/src/MetricDataPointsChannel';
import { MetricDataList } from '@tableau/search-microview-communication-channels/lib/src/types/MetricDataList';

import { MetricDataPoints } from '~src/metrics/resources/MetricDataPoints';

export function startListening(): () => void {
    const metricDataPointsChannel = new MetricDataPointsChannel();

    const stopListeningMetricDataPointsChannel = metricDataPointsChannel.listen((request) => {
        return new Promise<MetricDataList>((resolve, reject) => {
            MetricDataPoints.getMetricDataPoints(request.metricIds).then((result) => {
                resolve(result as MetricDataList);
            })
            .catch(error => reject(error));
        });
    });

    return () => {
        stopListeningMetricDataPointsChannel();
    };
}
